import React from 'react';
import './BarManyLinesChartSkeleton.scss';

const BarManyLinesChartSkeleton: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        background: '#292850FF',
        borderRadius: '12px',
        padding: '20px',
        color: 'white',
        border: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className="bar-many-lines-chart-skeleton__title" />
        <div className="bar-many-lines-chart-skeleton__view-btn" />
      </div>

      <div style={{ display: 'flex' }}>
        <div style={{ flex: 6 }}>
          <div className="bar-many-lines-chart-skeleton__chart" />
        </div>

        <div
          style={{
            flex: 1,
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '20px',
          }}
        >
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                background: '#57568EFF',
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                textAlign: 'center',
              }}
            >
              <div className="bar-many-lines-chart-skeleton__card-title" />
              <div className="bar-many-lines-chart-skeleton__card-value" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BarManyLinesChartSkeleton;
